import axios from "@/app/plugins/Axios";

function listar(paginacao) {
  return axios
    .get("lojas", { params: paginacao })
    .then((response) => response.data);
}

function listarLojas() {
  return axios
    .get("lojas/lista")
    .then((response) => response.data);
}

function buscar(busca) {
  return axios
    .get(`lojas/buscar?busca=${busca}`)
    .then((response) => response.data);
}

function buscarPorCodigo(codigo) {
  return axios
    .get(`lojas/buscarCodigo?codigo=${codigo}`)
    .then((response) => response.data);
}

function abrir(id) {
  return axios.get(`/lojas/${id}`).then((response) => response.data);
}

function salvar(loja) {
  return axios.post("/lojas", loja).then((response) => response.data);
}

function atualizar(loja) {
  return axios.put(`/lojas/${loja.id}`, loja).then((response) => response.data);
}

function excluir(id) {
  return axios.delete(`/lojas/${id}`).then((response) => response.data);
}

export default {
  listar,
  listarLojas,
  buscar,
  buscarPorCodigo,
  abrir,
  salvar,
  atualizar,
  excluir,
};
